import { Trash, UserPlus } from "@phosphor-icons/react";
import FriendsList from "components/friends-list";
import { useModal } from "context/ModalContext";
import { Button, Textarea } from "flowbite-react";
import { useCallback, useEffect, useState } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import ReactModal from "react-modal";
import { toast } from "react-toastify";
import { actionLog } from "services/actionlog.service";
import { sendMessage } from "services/messages.service";
import { clearNotifications } from "services/notifications.service";
import { submitRealLifeMission } from "services/reallife.service";
import { uploadFile } from "services/upload.service";
import { useAppStore } from "store";

export default function RealLifeInviteModal() {
  ReactModal.setAppElement("#modal");

  const modalID = "real-life-invite";

  const [modalIsOpen, setIsOpen] = useState(false);
  const { showModal, openModal, closeModal, modalData } = useModal();

  const [answer, setAnswer] = useState("");
  const [answerFile, setAnswerFile] = useState<File | null>(null);

  const [loading, setLoading] = useState(false);

  const [imagePreview, setImagePreview] = useState<any>();

  const { user, host, pointsHistory } = useAppStore();

  function afterOpenModal() {}

  const clearFile = useCallback(() => {
    setAnswerFile(null);
    setImagePreview(null);

    const fileInput = document.getElementById("file") as HTMLInputElement;
    if (fileInput) {
      fileInput.value = "";
    }
  }, []);

  const handleCloseModal = useCallback(() => {
    closeModal();
    setLoading(false);
    setAnswer("");
    setAnswerFile(null);
    clearFile();
  }, [clearFile, closeModal]);

  const handleInvite = useCallback(
    async (friend: any) => {
      console.log("handleInvite", friend, modalData._id);

      const payload = {
        to: [friend._id],
        content: modalData.title,
        mission: modalData._id,
        region: modalData.region,
        type: "notification",
        sender: "Custom",
        from: user?._id,
        time: new Date().getTime(),
        updated: null,
      };

      await actionLog("invite_friend_mission", {
        mission: modalData._id,
        friend: friend._id,
      });

      // setLoading(true);

      await sendMessage(payload);

      toast.info("Tu invitiación ha sido enviada");

      // setLoading(false);
    },
    [modalData, user],
  );

  useEffect(() => {
    if (openModal === modalID) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [openModal]);

  useEffect(() => {
    // if its an image file, display preview
    // display base64 image preview
    if (answerFile) {
      // check if any file is too big
      if (answerFile.size > 1024 * 1024 * 2) {
        alert("El archivo es demasiado grande. Máximo 2MB.");
        clearFile();
        return;
      }

      // check if file is an image
      if (!answerFile.type.includes("image")) {
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(answerFile);
    }
  }, [answerFile, clearFile]);

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Badge Modal"
        portalClassName="relative z-40"
        overlayClassName="fixed z-100 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center"
        contentElement={() => (
          <div>
            <div className="bg-white rounded-xl p-3 md:px-5 w-[450px] max-w-[97vw] max-h-[80vh] flex flex-col items-center flex-none mx-5 gap-1 overflow-y-auto">
              <h1 className="text-xl lg:text-3xl mt-2 font-bold text-blue-500 text-center">
                {modalData?.title}
              </h1>
              <p className="text-center leading-tight mb-2">
                Elige a los amigos que deseas invitar
                <br />
                para completar esta misión contigo.
              </p>
              {!loading ? (
                <>
                  <div className="w-full overflow-hidden relative border rounded-lg h-96">
                    <FriendsList
                      onFriendClick={(friend: any) => {
                        handleInvite(friend);
                      }}
                    />
                  </div>

                  <div className="py-2 relative z-10 flex gap-2">
                    <Button
                      fullSized
                      type="button"
                      onClick={() => handleCloseModal()}
                      className="bg-red-500"
                    >
                      CERRAR
                    </Button>
                  </div>
                </>
              ) : (
                <div>
                  <p>CARGANDO...</p>
                </div>
              )}
              {!loading ? (
                <div className="mx-auto flex flex-col items-center justify-center gap-2 pb-2">
                  <p>¿No encontraste a tu amigo?</p>
                  <Button
                    className="bg-brand-red text-white rounded-lg"
                    onClick={() => showModal("friend-invite")}
                  >
                    <div className="flex items-center justify-between">
                      <span>Invitar a un amigo</span>
                      <UserPlus className="ml-2 h-6 w-6" />
                    </div>
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
        )}
      />
    </>
  );
}
